(() => {
  const section = document.querySelector('.bsb-ch');
  if (!section) return;

  const video    = section.querySelector('.bsb-ch__video:not(.bsb-ch__video--embed)');
  const pauseBtn = section.querySelector('.bsb-ch__pause');

  if (video && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.pause();
    video.removeAttribute('autoplay');
  }

  if (video && pauseBtn) {
    const iconPlay  = pauseBtn.querySelector('.bsb-ch__pause-icon--play');
    const iconPause = pauseBtn.querySelector('.bsb-ch__pause-icon--pause');

    const syncState = () => {
      const paused = video.paused;
      pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      pauseBtn.setAttribute('aria-pressed', String(paused));
      paused ? iconPlay.removeAttribute('hidden') : iconPlay.setAttribute('hidden', '');
      paused ? iconPause.setAttribute('hidden', '') : iconPause.removeAttribute('hidden');
    };

    pauseBtn.addEventListener('click', () => {
      video.paused ? video.play() : video.pause();
      syncState();
    });

    video.addEventListener('play',  syncState);
    video.addEventListener('pause', syncState);
    syncState();
  }
})();
